module.exports = __webpack_public_path__ + "img/top.a14c398f.svg";